import { useEffect } from 'react';
import { graphql } from 'react-relay';

// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import { useMutationInterop } from '@confluence/apollo-relay-interop/entry-points/useMutationInterop.ts';

import { BulkUploadErrors } from './useHandleRejectedDocuments.ts';
import type {
	DeletePagesActionMutation as DeletePagesActionMutationData,
	DeletePagesActionMutationVariables,
} from './__types__/DeletePagesActionMutation.ts';

export const useHandleDeleteParentPage = (
	bulkError: string | null,
	bulkParentPageId: string | null,
	setBulkParentPageId: (id: null) => void,
): void => {
	const [deletePagesActionMutation] = useMutationInterop<
		DeletePagesActionMutationData,
		DeletePagesActionMutationVariables
	>(graphql`
		mutation useHandleDeleteParentPageMutation($input: [DeletePagesInput]!) {
			deletePages(input: $input) {
				taskId
				status
			}
		}
	`);

	useEffect(() => {
		if (bulkParentPageId && bulkError === BulkUploadErrors.ALL_REJECTED_ERROR) {
			const executeDeleteParentPage = async () => {
				try {
					setBulkParentPageId(null);

					await deletePagesActionMutation({
						variables: {
							input: [
								{
									pageID: parseInt(bulkParentPageId, 10),
									areChildrenIncluded: true,
									isSelected: true,
								},
							],
						},
					});
				} catch (e) {
					return e;
				}
			};

			void executeDeleteParentPage();
		}
	}, [bulkParentPageId, bulkError, setBulkParentPageId, deletePagesActionMutation]);
};
